import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/* Révélation au scroll — respecte prefers-reduced-motion */
export const Reveal = ({ children, className = "", delay = 0, y = 40, as: Tag = "div", ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.fromTo(
        el,
        { y, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, delay, ease: "power2.out", scrollTrigger: { trigger: el, start: "top 80%", once: true } }
      );
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.fromTo(el, { opacity: 0 }, { opacity: 1, duration: 0.2, scrollTrigger: { trigger: el, start: "top 85%", once: true } });
    });
    return () => mm.revert();
  }, [delay, y]);

  return (
    <Tag ref={ref} className={className} style={{ opacity: 0 }} data-reveal-self="" {...rest}>
      {children}
    </Tag>
  );
};

/* Révélation en cascade des enfants directs */
export const RevealStagger = ({ children, className = "", stagger = 0.08, ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const items = Array.from(el.children);
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.fromTo(
        items,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, stagger, ease: "power2.out", scrollTrigger: { trigger: el, start: "top 80%", once: true } }
      );
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(items, { opacity: 1 });
    });
    return () => mm.revert();
  }, [stagger]);

  return (
    <div ref={ref} className={className} data-reveal-stagger="" {...rest}>
      {children}
    </div>
  );
};
